import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type About = Document & {
  __typename?: 'About';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']>;
};

export type AboutFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  slug?: Maybe<SlugFilter>;
  title?: Maybe<StringFilter>;
};

export type AboutOrHomepageOrHorseOrHowItWorksOrPrivacyOrTerms = About | Homepage | Horse | HowItWorks | Privacy | Terms;

export type AboutSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  title?: Maybe<SortOrder>;
};

export type Block = {
  __typename?: 'Block';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Span>>>;
  list?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};

export type BlockOrIframeOrImageWithAltOrYoutube = Block | Iframe | ImageWithAlt | Youtube;

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Boolean']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Boolean']>;
};

export type CaseStudies = {
  __typename?: 'CaseStudies';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  caseStudiesRepeater?: Maybe<Array<Maybe<CaseStudy>>>;
  heading?: Maybe<Scalars['String']>;
  snippet?: Maybe<Scalars['String']>;
};

export type CaseStudiesFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  heading?: Maybe<StringFilter>;
  snippet?: Maybe<StringFilter>;
};

export type CaseStudiesSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  heading?: Maybe<SortOrder>;
  snippet?: Maybe<SortOrder>;
};

export type CaseStudy = Document & {
  __typename?: 'CaseStudy';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Placeholder */
  caseStudy?: Maybe<Scalars['String']>;
};

export type CaseStudyFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  caseStudy?: Maybe<StringFilter>;
};

export type CaseStudySorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  caseStudy?: Maybe<SortOrder>;
};

export type CompanyInfo = Document & {
  __typename?: 'CompanyInfo';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  legalDisclaimerRaw?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
};

export type CompanyInfoFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  email?: Maybe<StringFilter>;
  phone?: Maybe<StringFilter>;
};

export type CompanyInfoSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
};

export type CtaObject = {
  __typename?: 'CtaObject';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type CtaObjectFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  link?: Maybe<StringFilter>;
  text?: Maybe<StringFilter>;
};

export type CtaObjectSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  link?: Maybe<SortOrder>;
  text?: Maybe<SortOrder>;
};

export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Date']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Date']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Date']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Date']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Date']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Date']>;
};

export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['DateTime']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['DateTime']>;
};

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
};

export type DocumentSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
};

export type File = {
  __typename?: 'File';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
};

export type FileFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityFileAssetFilter>;
};

export type FileSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
};

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Float']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Float']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Float']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Float']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Float']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Float']>;
};

export type Footer = Document & {
  __typename?: 'Footer';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  navigation?: Maybe<Array<Maybe<NavigationItem>>>;
};

export type FooterFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
};

export type FooterSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
};

export type Geopoint = {
  __typename?: 'Geopoint';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GeopointFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  alt?: Maybe<FloatFilter>;
  lat?: Maybe<FloatFilter>;
  lng?: Maybe<FloatFilter>;
};

export type GeopointSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  alt?: Maybe<SortOrder>;
  lat?: Maybe<SortOrder>;
  lng?: Maybe<SortOrder>;
};

export type GetStarted = {
  __typename?: 'GetStarted';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  ctaObject?: Maybe<CtaObject>;
  heading?: Maybe<Scalars['String']>;
  snippet?: Maybe<Scalars['String']>;
};

export type GetStartedFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  ctaObject?: Maybe<CtaObjectFilter>;
  heading?: Maybe<StringFilter>;
  snippet?: Maybe<StringFilter>;
};

export type GetStartedSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  ctaObject?: Maybe<CtaObjectSorting>;
  heading?: Maybe<SortOrder>;
  snippet?: Maybe<SortOrder>;
};

export type Header = Document & {
  __typename?: 'Header';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  navigation?: Maybe<Array<Maybe<NavigationItem>>>;
};

export type HeaderFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
};

export type HeaderSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
};

export type Hero = {
  __typename?: 'Hero';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  ctaObject?: Maybe<CtaObject>;
  heading?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  snippet?: Maybe<Scalars['String']>;
};

export type HeroFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  ctaObject?: Maybe<CtaObjectFilter>;
  heading?: Maybe<StringFilter>;
  image?: Maybe<ImageFilter>;
  snippet?: Maybe<StringFilter>;
};

export type HeroSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  ctaObject?: Maybe<CtaObjectSorting>;
  heading?: Maybe<SortOrder>;
  image?: Maybe<ImageSorting>;
  snippet?: Maybe<SortOrder>;
};

export type Homepage = Document & {
  __typename?: 'Homepage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  caseStudies?: Maybe<CaseStudies>;
  getStarted?: Maybe<GetStarted>;
  hero?: Maybe<Hero>;
  howItWorksSection?: Maybe<HowItWorksSection>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']>;
};

export type HomepageFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  caseStudies?: Maybe<CaseStudiesFilter>;
  getStarted?: Maybe<GetStartedFilter>;
  hero?: Maybe<HeroFilter>;
  howItWorksSection?: Maybe<HowItWorksSectionFilter>;
  slug?: Maybe<SlugFilter>;
  title?: Maybe<StringFilter>;
};

export type HomepageSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  caseStudies?: Maybe<CaseStudiesSorting>;
  getStarted?: Maybe<GetStartedSorting>;
  hero?: Maybe<HeroSorting>;
  howItWorksSection?: Maybe<HowItWorksSectionSorting>;
  slug?: Maybe<SlugSorting>;
  title?: Maybe<SortOrder>;
};

export type Horse = Document & {
  __typename?: 'Horse';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  assetGallery?: Maybe<Array<Maybe<Image>>>;
  availableShares?: Maybe<Scalars['Float']>;
  fundingCloseDate?: Maybe<Scalars['Date']>;
  horseDetails?: Maybe<HorseDetails>;
  horseName?: Maybe<Scalars['String']>;
  mainDescriptionRaw?: Maybe<Scalars['JSON']>;
  og?: Maybe<OpenGraphProperties>;
  price?: Maybe<Scalars['Float']>;
  slug?: Maybe<Slug>;
  videos?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HorseDetails = {
  __typename?: 'HorseDetails';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  breed?: Maybe<Scalars['String']>;
  dam?: Maybe<Scalars['String']>;
  dressageShowingLevel?: Maybe<Scalars['Float']>;
  dressageTrainingLevel?: Maybe<Scalars['Float']>;
  foaled?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  huntLevel?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  registered?: Maybe<Scalars['Boolean']>;
  registries?: Maybe<Scalars['String']>;
  sire?: Maybe<Scalars['String']>;
};

export type HorseDetailsFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  breed?: Maybe<StringFilter>;
  dam?: Maybe<StringFilter>;
  dressageShowingLevel?: Maybe<FloatFilter>;
  dressageTrainingLevel?: Maybe<FloatFilter>;
  foaled?: Maybe<StringFilter>;
  gender?: Maybe<StringFilter>;
  huntLevel?: Maybe<StringFilter>;
  location?: Maybe<StringFilter>;
  registered?: Maybe<BooleanFilter>;
  registries?: Maybe<StringFilter>;
  sire?: Maybe<StringFilter>;
};

export type HorseDetailsSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  breed?: Maybe<SortOrder>;
  dam?: Maybe<SortOrder>;
  dressageShowingLevel?: Maybe<SortOrder>;
  dressageTrainingLevel?: Maybe<SortOrder>;
  foaled?: Maybe<SortOrder>;
  gender?: Maybe<SortOrder>;
  huntLevel?: Maybe<SortOrder>;
  location?: Maybe<SortOrder>;
  registered?: Maybe<SortOrder>;
  registries?: Maybe<SortOrder>;
  sire?: Maybe<SortOrder>;
};

export type HorseFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  availableShares?: Maybe<FloatFilter>;
  fundingCloseDate?: Maybe<DateFilter>;
  horseDetails?: Maybe<HorseDetailsFilter>;
  horseName?: Maybe<StringFilter>;
  og?: Maybe<OpenGraphPropertiesFilter>;
  price?: Maybe<FloatFilter>;
  slug?: Maybe<SlugFilter>;
};

export type HorseSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  availableShares?: Maybe<SortOrder>;
  fundingCloseDate?: Maybe<SortOrder>;
  horseDetails?: Maybe<HorseDetailsSorting>;
  horseName?: Maybe<SortOrder>;
  og?: Maybe<OpenGraphPropertiesSorting>;
  price?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
};

export type HowItWorks = Document & {
  __typename?: 'HowItWorks';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']>;
};

export type HowItWorksFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  slug?: Maybe<SlugFilter>;
  title?: Maybe<StringFilter>;
};

export type HowItWorksItem = {
  __typename?: 'HowItWorksItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  snippet?: Maybe<Scalars['String']>;
};

export type HowItWorksItemFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  heading?: Maybe<StringFilter>;
  image?: Maybe<ImageFilter>;
  snippet?: Maybe<StringFilter>;
};

export type HowItWorksItemSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  heading?: Maybe<SortOrder>;
  image?: Maybe<ImageSorting>;
  snippet?: Maybe<SortOrder>;
};

export type HowItWorksSection = {
  __typename?: 'HowItWorksSection';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  ctaObject?: Maybe<CtaObject>;
  heading?: Maybe<Scalars['String']>;
  howItWorksRepeater?: Maybe<Array<Maybe<HowItWorksItem>>>;
  snippet?: Maybe<Scalars['String']>;
};

export type HowItWorksSectionFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  ctaObject?: Maybe<CtaObjectFilter>;
  heading?: Maybe<StringFilter>;
  snippet?: Maybe<StringFilter>;
};

export type HowItWorksSectionSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  ctaObject?: Maybe<CtaObjectSorting>;
  heading?: Maybe<SortOrder>;
  snippet?: Maybe<SortOrder>;
};

export type HowItWorksSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  title?: Maybe<SortOrder>;
};

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
  /** Checks if the value matches the given word/words. */
  matches?: Maybe<Scalars['ID']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['ID']>;
  nin?: Maybe<Array<Scalars['ID']>>;
};

export type Iframe = {
  __typename?: 'Iframe';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  embed?: Maybe<Scalars['String']>;
};

export type IframeFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  embed?: Maybe<StringFilter>;
};

export type IframeSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  embed?: Maybe<SortOrder>;
};

export type Image = {
  __typename?: 'Image';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
};

export type ImageFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  asset?: Maybe<SanityImageAssetFilter>;
  crop?: Maybe<SanityImageCropFilter>;
  hotspot?: Maybe<SanityImageHotspotFilter>;
};

export type ImageSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  crop?: Maybe<SanityImageCropSorting>;
  hotspot?: Maybe<SanityImageHotspotSorting>;
};

export type ImageWithAlt = {
  __typename?: 'ImageWithAlt';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Important for SEO and accessibility. */
  alt?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
};

export type ImageWithAltFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  alt?: Maybe<StringFilter>;
  asset?: Maybe<SanityImageAssetFilter>;
  crop?: Maybe<SanityImageCropFilter>;
  hotspot?: Maybe<SanityImageHotspotFilter>;
};

export type ImageWithAltSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  alt?: Maybe<SortOrder>;
  crop?: Maybe<SanityImageCropSorting>;
  hotspot?: Maybe<SanityImageHotspotSorting>;
};

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['Int']>;
  /** Checks if the value is greater than the given input. */
  gt?: Maybe<Scalars['Int']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: Maybe<Scalars['Int']>;
  /** Checks if the value is lesser than the given input. */
  lt?: Maybe<Scalars['Int']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: Maybe<Scalars['Int']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['Int']>;
};

export type MediaTag = Document & {
  __typename?: 'MediaTag';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Slug>;
};

export type MediaTagFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  name?: Maybe<SlugFilter>;
};

export type MediaTagSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  name?: Maybe<SlugSorting>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Reference a document to override the fields below and use the document values instead */
  document?: Maybe<AboutOrHomepageOrHorseOrHowItWorksOrPrivacyOrTerms>;
  /** Link text */
  label?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type NavigationItemFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  path?: Maybe<StringFilter>;
};

export type NavigationItemSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type OpenGraphProperties = {
  __typename?: 'OpenGraphProperties';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Short description displayed when sharing on social. Highly recommended for SEO. */
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  /** Optionally override main title. */
  title?: Maybe<Scalars['String']>;
};

export type OpenGraphPropertiesFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  image?: Maybe<ImageFilter>;
  title?: Maybe<StringFilter>;
};

export type OpenGraphPropertiesSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  image?: Maybe<ImageSorting>;
  title?: Maybe<SortOrder>;
};

export type Person = Document & {
  __typename?: 'Person';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  bio?: Maybe<Scalars['String']>;
  byline?: Maybe<Scalars['String']>;
  headshot?: Maybe<ImageWithAlt>;
  name?: Maybe<Scalars['String']>;
  /** Include just the handle.  Ex: "austin_rief" */
  twitter?: Maybe<Scalars['String']>;
  /** Must be unique. Cannot contain spaces. */
  username?: Maybe<Scalars['String']>;
};

export type PersonFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  bio?: Maybe<StringFilter>;
  byline?: Maybe<StringFilter>;
  headshot?: Maybe<ImageWithAltFilter>;
  name?: Maybe<StringFilter>;
  twitter?: Maybe<StringFilter>;
  username?: Maybe<StringFilter>;
};

export type PersonSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  bio?: Maybe<SortOrder>;
  byline?: Maybe<SortOrder>;
  headshot?: Maybe<ImageWithAltSorting>;
  name?: Maybe<SortOrder>;
  twitter?: Maybe<SortOrder>;
  username?: Maybe<SortOrder>;
};

export type Privacy = Document & {
  __typename?: 'Privacy';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  contentRaw?: Maybe<Scalars['JSON']>;
  mainHeading?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']>;
};

export type PrivacyFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  mainHeading?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  title?: Maybe<StringFilter>;
};

export type PrivacySorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  mainHeading?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  title?: Maybe<SortOrder>;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  About?: Maybe<About>;
  CaseStudy?: Maybe<CaseStudy>;
  CompanyInfo?: Maybe<CompanyInfo>;
  Document?: Maybe<Document>;
  Footer?: Maybe<Footer>;
  Header?: Maybe<Header>;
  Homepage?: Maybe<Homepage>;
  Horse?: Maybe<Horse>;
  HowItWorks?: Maybe<HowItWorks>;
  MediaTag?: Maybe<MediaTag>;
  Person?: Maybe<Person>;
  Privacy?: Maybe<Privacy>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  SiteSettings?: Maybe<SiteSettings>;
  TagStory?: Maybe<TagStory>;
  Terms?: Maybe<Terms>;
  Vertical?: Maybe<Vertical>;
  allAbout: Array<About>;
  allCaseStudy: Array<CaseStudy>;
  allCompanyInfo: Array<CompanyInfo>;
  allDocument: Array<Document>;
  allFooter: Array<Footer>;
  allHeader: Array<Header>;
  allHomepage: Array<Homepage>;
  allHorse: Array<Horse>;
  allHowItWorks: Array<HowItWorks>;
  allMediaTag: Array<MediaTag>;
  allPerson: Array<Person>;
  allPrivacy: Array<Privacy>;
  allSanityFileAsset: Array<SanityFileAsset>;
  allSanityImageAsset: Array<SanityImageAsset>;
  allSiteSettings: Array<SiteSettings>;
  allTagStory: Array<TagStory>;
  allTerms: Array<Terms>;
  allVertical: Array<Vertical>;
};


export type RootQueryAboutArgs = {
  id: Scalars['ID'];
};


export type RootQueryCaseStudyArgs = {
  id: Scalars['ID'];
};


export type RootQueryCompanyInfoArgs = {
  id: Scalars['ID'];
};


export type RootQueryDocumentArgs = {
  id: Scalars['ID'];
};


export type RootQueryFooterArgs = {
  id: Scalars['ID'];
};


export type RootQueryHeaderArgs = {
  id: Scalars['ID'];
};


export type RootQueryHomepageArgs = {
  id: Scalars['ID'];
};


export type RootQueryHorseArgs = {
  id: Scalars['ID'];
};


export type RootQueryHowItWorksArgs = {
  id: Scalars['ID'];
};


export type RootQueryMediaTagArgs = {
  id: Scalars['ID'];
};


export type RootQueryPersonArgs = {
  id: Scalars['ID'];
};


export type RootQueryPrivacyArgs = {
  id: Scalars['ID'];
};


export type RootQuerySanityFileAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuerySanityImageAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuerySiteSettingsArgs = {
  id: Scalars['ID'];
};


export type RootQueryTagStoryArgs = {
  id: Scalars['ID'];
};


export type RootQueryTermsArgs = {
  id: Scalars['ID'];
};


export type RootQueryVerticalArgs = {
  id: Scalars['ID'];
};


export type RootQueryAllAboutArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<AboutSorting>>;
  where?: Maybe<AboutFilter>;
};


export type RootQueryAllCaseStudyArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<CaseStudySorting>>;
  where?: Maybe<CaseStudyFilter>;
};


export type RootQueryAllCompanyInfoArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<CompanyInfoSorting>>;
  where?: Maybe<CompanyInfoFilter>;
};


export type RootQueryAllDocumentArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<DocumentSorting>>;
  where?: Maybe<DocumentFilter>;
};


export type RootQueryAllFooterArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<FooterSorting>>;
  where?: Maybe<FooterFilter>;
};


export type RootQueryAllHeaderArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<HeaderSorting>>;
  where?: Maybe<HeaderFilter>;
};


export type RootQueryAllHomepageArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<HomepageSorting>>;
  where?: Maybe<HomepageFilter>;
};


export type RootQueryAllHorseArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<HorseSorting>>;
  where?: Maybe<HorseFilter>;
};


export type RootQueryAllHowItWorksArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<HowItWorksSorting>>;
  where?: Maybe<HowItWorksFilter>;
};


export type RootQueryAllMediaTagArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<MediaTagSorting>>;
  where?: Maybe<MediaTagFilter>;
};


export type RootQueryAllPersonArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<PersonSorting>>;
  where?: Maybe<PersonFilter>;
};


export type RootQueryAllPrivacyArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<PrivacySorting>>;
  where?: Maybe<PrivacyFilter>;
};


export type RootQueryAllSanityFileAssetArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<SanityFileAssetSorting>>;
  where?: Maybe<SanityFileAssetFilter>;
};


export type RootQueryAllSanityImageAssetArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<SanityImageAssetSorting>>;
  where?: Maybe<SanityImageAssetFilter>;
};


export type RootQueryAllSiteSettingsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<SiteSettingsSorting>>;
  where?: Maybe<SiteSettingsFilter>;
};


export type RootQueryAllTagStoryArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<TagStorySorting>>;
  where?: Maybe<TagStoryFilter>;
};


export type RootQueryAllTermsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<TermsSorting>>;
  where?: Maybe<TermsFilter>;
};


export type RootQueryAllVerticalArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<VerticalSorting>>;
  where?: Maybe<VerticalFilter>;
};

export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']>;
};

export type SanityAssetSourceDataFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type SanityAssetSourceDataSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  altText?: Maybe<StringFilter>;
  assetId?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  extension?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  mimeType?: Maybe<StringFilter>;
  originalFilename?: Maybe<StringFilter>;
  path?: Maybe<StringFilter>;
  sha1hash?: Maybe<StringFilter>;
  size?: Maybe<FloatFilter>;
  source?: Maybe<SanityAssetSourceDataFilter>;
  title?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type SanityFileAssetSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  altText?: Maybe<SortOrder>;
  assetId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  mimeType?: Maybe<SortOrder>;
  originalFilename?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  sha1hash?: Maybe<SortOrder>;
  size?: Maybe<SortOrder>;
  source?: Maybe<SanityAssetSourceDataSorting>;
  title?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  altText?: Maybe<StringFilter>;
  assetId?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  extension?: Maybe<StringFilter>;
  label?: Maybe<StringFilter>;
  metadata?: Maybe<SanityImageMetadataFilter>;
  mimeType?: Maybe<StringFilter>;
  originalFilename?: Maybe<StringFilter>;
  path?: Maybe<StringFilter>;
  sha1hash?: Maybe<StringFilter>;
  size?: Maybe<FloatFilter>;
  source?: Maybe<SanityAssetSourceDataFilter>;
  title?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type SanityImageAssetSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  altText?: Maybe<SortOrder>;
  assetId?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  extension?: Maybe<SortOrder>;
  label?: Maybe<SortOrder>;
  metadata?: Maybe<SanityImageMetadataSorting>;
  mimeType?: Maybe<SortOrder>;
  originalFilename?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  sha1hash?: Maybe<SortOrder>;
  size?: Maybe<SortOrder>;
  source?: Maybe<SanityAssetSourceDataSorting>;
  title?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type SanityImageCropFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  bottom?: Maybe<FloatFilter>;
  left?: Maybe<FloatFilter>;
  right?: Maybe<FloatFilter>;
  top?: Maybe<FloatFilter>;
};

export type SanityImageCropSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  bottom?: Maybe<SortOrder>;
  left?: Maybe<SortOrder>;
  right?: Maybe<SortOrder>;
  top?: Maybe<SortOrder>;
};

export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type SanityImageDimensionsFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  aspectRatio?: Maybe<FloatFilter>;
  height?: Maybe<FloatFilter>;
  width?: Maybe<FloatFilter>;
};

export type SanityImageDimensionsSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  aspectRatio?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
};

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspotFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  height?: Maybe<FloatFilter>;
  width?: Maybe<FloatFilter>;
  x?: Maybe<FloatFilter>;
  y?: Maybe<FloatFilter>;
};

export type SanityImageHotspotSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  height?: Maybe<SortOrder>;
  width?: Maybe<SortOrder>;
  x?: Maybe<SortOrder>;
  y?: Maybe<SortOrder>;
};

export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  isOpaque?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Geopoint>;
  lqip?: Maybe<Scalars['String']>;
  palette?: Maybe<SanityImagePalette>;
};

export type SanityImageMetadataFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  dimensions?: Maybe<SanityImageDimensionsFilter>;
  hasAlpha?: Maybe<BooleanFilter>;
  isOpaque?: Maybe<BooleanFilter>;
  location?: Maybe<GeopointFilter>;
  lqip?: Maybe<StringFilter>;
  palette?: Maybe<SanityImagePaletteFilter>;
};

export type SanityImageMetadataSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  dimensions?: Maybe<SanityImageDimensionsSorting>;
  hasAlpha?: Maybe<SortOrder>;
  isOpaque?: Maybe<SortOrder>;
  location?: Maybe<GeopointSorting>;
  lqip?: Maybe<SortOrder>;
  palette?: Maybe<SanityImagePaletteSorting>;
};

export type SanityImagePalette = {
  __typename?: 'SanityImagePalette';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};

export type SanityImagePaletteFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  darkMuted?: Maybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: Maybe<SanityImagePaletteSwatchFilter>;
  dominant?: Maybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: Maybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: Maybe<SanityImagePaletteSwatchFilter>;
  muted?: Maybe<SanityImagePaletteSwatchFilter>;
  vibrant?: Maybe<SanityImagePaletteSwatchFilter>;
};

export type SanityImagePaletteSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  darkMuted?: Maybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: Maybe<SanityImagePaletteSwatchSorting>;
  dominant?: Maybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: Maybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: Maybe<SanityImagePaletteSwatchSorting>;
  muted?: Maybe<SanityImagePaletteSwatchSorting>;
  vibrant?: Maybe<SanityImagePaletteSwatchSorting>;
};

export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  foreground?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type SanityImagePaletteSwatchFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  background?: Maybe<StringFilter>;
  foreground?: Maybe<StringFilter>;
  population?: Maybe<FloatFilter>;
  title?: Maybe<StringFilter>;
};

export type SanityImagePaletteSwatchSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  background?: Maybe<SortOrder>;
  foreground?: Maybe<SortOrder>;
  population?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
};

export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: Maybe<Scalars['Boolean']>;
  /** All documents referencing the given document ID. */
  references?: Maybe<Scalars['ID']>;
};

export type ShareLinks = {
  __typename?: 'ShareLinks';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ShareLinksFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  facebook?: Maybe<StringFilter>;
  linkedin?: Maybe<StringFilter>;
  twitter?: Maybe<StringFilter>;
  website?: Maybe<StringFilter>;
};

export type ShareLinksSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  facebook?: Maybe<SortOrder>;
  linkedin?: Maybe<SortOrder>;
  twitter?: Maybe<SortOrder>;
  website?: Maybe<SortOrder>;
};

export type SiteSettings = Document & {
  __typename?: 'SiteSettings';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Placeholder. Settings will go here */
  settings?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SiteSettingsFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  settings?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type SiteSettingsSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  settings?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
};

export type Slug = {
  __typename?: 'Slug';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
};

export type SlugFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  current?: Maybe<StringFilter>;
};

export type SlugSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  current?: Maybe<SortOrder>;
};

export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC'
}

export type Span = {
  __typename?: 'Span';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  /** Checks if the value matches the given word/words. */
  matches?: Maybe<Scalars['String']>;
  /** Checks if the value is not equal to the given input. */
  neq?: Maybe<Scalars['String']>;
  nin?: Maybe<Array<Scalars['String']>>;
};

export type TagStory = Document & {
  __typename?: 'TagStory';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

export type TagStoryFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  name?: Maybe<StringFilter>;
};

export type TagStorySorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type Terms = Document & {
  __typename?: 'Terms';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  contentRaw?: Maybe<Scalars['JSON']>;
  mainHeading?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']>;
};

export type TermsFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  mainHeading?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  title?: Maybe<StringFilter>;
};

export type TermsSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  mainHeading?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  title?: Maybe<SortOrder>;
};

export type Vertical = Document & {
  __typename?: 'Vertical';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  ctaDescription?: Maybe<Scalars['String']>;
  ctaHeading?: Maybe<Scalars['String']>;
  /** Example: 'MorningBrew' */
  facebook?: Maybe<Scalars['String']>;
  featuredStories?: Maybe<Array<Maybe<Horse>>>;
  /** Example: 'morningbrew' */
  instagram?: Maybe<Scalars['String']>;
  logo?: Maybe<ImageWithAlt>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  /** Example: 'morningbrew' */
  twitter?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type VerticalFilter = {
  /** Apply filters on document level */
  _?: Maybe<Sanity_DocumentFilter>;
  _createdAt?: Maybe<DatetimeFilter>;
  _id?: Maybe<IdFilter>;
  _key?: Maybe<StringFilter>;
  _rev?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  _updatedAt?: Maybe<DatetimeFilter>;
  ctaDescription?: Maybe<StringFilter>;
  ctaHeading?: Maybe<StringFilter>;
  facebook?: Maybe<StringFilter>;
  instagram?: Maybe<StringFilter>;
  logo?: Maybe<ImageWithAltFilter>;
  name?: Maybe<StringFilter>;
  slug?: Maybe<SlugFilter>;
  twitter?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type VerticalSorting = {
  _createdAt?: Maybe<SortOrder>;
  _id?: Maybe<SortOrder>;
  _key?: Maybe<SortOrder>;
  _rev?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  _updatedAt?: Maybe<SortOrder>;
  ctaDescription?: Maybe<SortOrder>;
  ctaHeading?: Maybe<SortOrder>;
  facebook?: Maybe<SortOrder>;
  instagram?: Maybe<SortOrder>;
  logo?: Maybe<ImageWithAltSorting>;
  name?: Maybe<SortOrder>;
  slug?: Maybe<SlugSorting>;
  twitter?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

export type Youtube = {
  __typename?: 'Youtube';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type YoutubeFilter = {
  _key?: Maybe<StringFilter>;
  _type?: Maybe<StringFilter>;
  url?: Maybe<StringFilter>;
};

export type YoutubeSorting = {
  _key?: Maybe<SortOrder>;
  _type?: Maybe<SortOrder>;
  url?: Maybe<SortOrder>;
};

type DiscriminateUnion<T, U> = T extends U ? T : never;

export type NavFragmentDocument = (NonNullable<NavFragmentFragment['document']>);
export type NavFragmentHorseInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Horse' }>);
export type NavFragmentSlug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Horse' }>)['slug']>);
export type NavFragmentPrivacyInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Privacy' }>);
export type NavFragment_Slug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Privacy' }>)['slug']>);
export type NavFragmentTermsInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Terms' }>);
export type NavFragment__Slug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Terms' }>)['slug']>);
export type NavFragmentHomepageInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Homepage' }>);
export type NavFragment___Slug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'Homepage' }>)['slug']>);
export type NavFragmentAboutInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'About' }>);
export type NavFragment____Slug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'About' }>)['slug']>);
export type NavFragmentHowItWorksInlineFragment = (DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'HowItWorks' }>);
export type NavFragment_____Slug = (NonNullable<(DiscriminateUnion<(NonNullable<NavFragmentFragment['document']>), { __typename?: 'HowItWorks' }>)['slug']>);
export type GlobalVariables = GlobalQueryVariables;
export type GlobalHeader = (NonNullable<GlobalQuery['header']>);
export type GlobalNavigation = NonNullable<(NonNullable<(NonNullable<GlobalQuery['header']>)['navigation']>)[number]>;
export type GlobalNavigationItemInlineFragment = ({ __typename: 'NavigationItem' } & Pick<NonNullable<(NonNullable<(NonNullable<GlobalQuery['header']>)['navigation']>)[number]>, keyof NavFragmentFragment>);
export type GlobalFooter = (NonNullable<GlobalQuery['footer']>);
export type Global_Navigation = NonNullable<(NonNullable<(NonNullable<GlobalQuery['footer']>)['navigation']>)[number]>;
export type Global_NavigationItemInlineFragment = ({ __typename: 'NavigationItem' } & Pick<NonNullable<(NonNullable<(NonNullable<GlobalQuery['footer']>)['navigation']>)[number]>, keyof NavFragmentFragment>);
export type GlobalCompanyInfo = (NonNullable<GlobalQuery['companyInfo']>);
export type GlobalCompanyInfoInlineFragment = ({ __typename: 'CompanyInfo' } & Pick<(NonNullable<GlobalQuery['companyInfo']>), 'email' | 'phone' | 'legalDisclaimerRaw'>);
export type GlobalSiteSettings = (NonNullable<GlobalQuery['siteSettings']>);
export type GlobalSiteSettingsInlineFragment = ({ __typename: 'SiteSettings' } & Pick<(NonNullable<GlobalQuery['siteSettings']>), 'settings'>);
export const useGlobal = useGlobalQuery;
export type HomepageVariables = HomepageQueryVariables;
export type HomepageHomepage = (NonNullable<HomepageQuery['homepage']>);
export type HomepageHero = (NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>);
export type HomepageHeroInlineFragment = ({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>);
export type HomepageImage = (NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['image']>);
export type HomepageImageInlineFragment = ({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['image']>), '_key' | 'asset'>);
export type HomepageAsset = (NonNullable<({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['image']>), '_key' | 'asset'>)['asset']>);
export type HomepageSanityImageAssetInlineFragment = ({ __typename: 'SanityImageAsset' } & Pick<(NonNullable<({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['image']>), '_key' | 'asset'>)['asset']>), '_id' | '_key' | 'url'>);
export type HomepageCtaObject = (NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['ctaObject']>);
export type HomepageCtaObjectInlineFragment = ({ __typename: 'CtaObject' } & Pick<(NonNullable<({ __typename: 'Hero' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['hero']>), 'image' | 'heading' | 'snippet' | 'ctaObject'>)['ctaObject']>), 'text' | 'link'>);
export type HomepageHowItWorksSection = (NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>);
export type HomepageHowItWorksSectionInlineFragment = ({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>);
export type HomepageHowItWorksRepeater = NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>;
export type HomepageHowItWorksItemInlineFragment = ({ __typename: 'HowItWorksItem' } & Pick<NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>, 'image' | 'heading' | 'snippet'>);
export type Homepage_Image = (NonNullable<({ __typename: 'HowItWorksItem' } & Pick<NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>, 'image' | 'heading' | 'snippet'>)['image']>);
export type Homepage_ImageInlineFragment = ({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'HowItWorksItem' } & Pick<NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>, 'image' | 'heading' | 'snippet'>)['image']>), '_key' | 'asset'>);
export type Homepage_Asset = (NonNullable<({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'HowItWorksItem' } & Pick<NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>, 'image' | 'heading' | 'snippet'>)['image']>), '_key' | 'asset'>)['asset']>);
export type Homepage_SanityImageAssetInlineFragment = ({ __typename: 'SanityImageAsset' } & Pick<(NonNullable<({ __typename: 'Image' } & Pick<(NonNullable<({ __typename: 'HowItWorksItem' } & Pick<NonNullable<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['howItWorksRepeater']>)[number]>, 'image' | 'heading' | 'snippet'>)['image']>), '_key' | 'asset'>)['asset']>), '_id' | '_key' | 'url'>);
export type Homepage_CtaObject = (NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['ctaObject']>);
export type Homepage_CtaObjectInlineFragment = ({ __typename: 'CtaObject' } & Pick<(NonNullable<({ __typename: 'HowItWorksSection' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['howItWorksSection']>), 'heading' | 'snippet' | 'howItWorksRepeater' | 'ctaObject'>)['ctaObject']>), 'text' | 'link'>);
export type HomepageCaseStudies = (NonNullable<(NonNullable<HomepageQuery['homepage']>)['caseStudies']>);
export type HomepageCaseStudiesInlineFragment = ({ __typename: 'CaseStudies' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['caseStudies']>), 'heading' | 'snippet' | 'caseStudiesRepeater'>);
export type HomepageCaseStudiesRepeater = NonNullable<(NonNullable<({ __typename: 'CaseStudies' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['caseStudies']>), 'heading' | 'snippet' | 'caseStudiesRepeater'>)['caseStudiesRepeater']>)[number]>;
export type HomepageCaseStudyInlineFragment = ({ __typename: 'CaseStudy' } & Pick<NonNullable<(NonNullable<({ __typename: 'CaseStudies' } & Pick<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['caseStudies']>), 'heading' | 'snippet' | 'caseStudiesRepeater'>)['caseStudiesRepeater']>)[number]>, 'caseStudy'>);
export type HomepageGetStarted = (NonNullable<(NonNullable<HomepageQuery['homepage']>)['getStarted']>);
export type Homepage__CtaObject = (NonNullable<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['getStarted']>)['ctaObject']>);
export type Homepage__CtaObjectInlineFragment = ({ __typename: 'CtaObject' } & Pick<(NonNullable<(NonNullable<(NonNullable<HomepageQuery['homepage']>)['getStarted']>)['ctaObject']>), 'text' | 'link'>);
export const useHomepage = useHomepageQuery;
export type NavFragmentFragment = { __typename?: 'NavigationItem', _key?: string | null | undefined, label?: string | null | undefined, path?: string | null | undefined, document?: { __typename?: 'About', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Homepage', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Horse', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'HowItWorks', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Privacy', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Terms', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | null | undefined };

export type GlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalQuery = { __typename?: 'RootQuery', header?: { __typename?: 'Header', _id?: string | null | undefined, _type?: string | null | undefined, navigation?: Array<{ __typename?: 'NavigationItem', _key?: string | null | undefined, label?: string | null | undefined, path?: string | null | undefined, document?: { __typename?: 'About', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Homepage', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Horse', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'HowItWorks', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Privacy', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Terms', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, footer?: { __typename?: 'Footer', _id?: string | null | undefined, _type?: string | null | undefined, navigation?: Array<{ __typename?: 'NavigationItem', _key?: string | null | undefined, label?: string | null | undefined, path?: string | null | undefined, document?: { __typename?: 'About', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Homepage', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Horse', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'HowItWorks', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Privacy', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | { __typename?: 'Terms', slug?: { __typename?: 'Slug', current?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, companyInfo?: { __typename?: 'CompanyInfo', email?: string | null | undefined, phone?: string | null | undefined, legalDisclaimerRaw?: any | null | undefined, _id?: string | null | undefined, _type?: string | null | undefined } | null | undefined, siteSettings?: { __typename?: 'SiteSettings', settings?: string | null | undefined, _id?: string | null | undefined, _type?: string | null | undefined } | null | undefined };

export type HomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageQuery = { __typename?: 'RootQuery', homepage?: { __typename?: 'Homepage', hero?: { __typename?: 'Hero', heading?: string | null | undefined, snippet?: string | null | undefined, image?: { __typename?: 'Image', _key?: string | null | undefined, asset?: { __typename?: 'SanityImageAsset', _id?: string | null | undefined, _key?: string | null | undefined, url?: string | null | undefined } | null | undefined } | null | undefined, ctaObject?: { __typename?: 'CtaObject', text?: string | null | undefined, link?: string | null | undefined } | null | undefined } | null | undefined, howItWorksSection?: { __typename?: 'HowItWorksSection', heading?: string | null | undefined, snippet?: string | null | undefined, howItWorksRepeater?: Array<{ __typename?: 'HowItWorksItem', heading?: string | null | undefined, snippet?: string | null | undefined, image?: { __typename?: 'Image', _key?: string | null | undefined, asset?: { __typename?: 'SanityImageAsset', _id?: string | null | undefined, _key?: string | null | undefined, url?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, ctaObject?: { __typename?: 'CtaObject', text?: string | null | undefined, link?: string | null | undefined } | null | undefined } | null | undefined, caseStudies?: { __typename?: 'CaseStudies', heading?: string | null | undefined, snippet?: string | null | undefined, caseStudiesRepeater?: Array<{ __typename?: 'CaseStudy', caseStudy?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, getStarted?: { __typename?: 'GetStarted', heading?: string | null | undefined, snippet?: string | null | undefined, ctaObject?: { __typename?: 'CtaObject', text?: string | null | undefined, link?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export const NavFragmentFragmentDoc = gql`
    fragment NavFragment on NavigationItem {
  _key
  document {
    ... on Horse {
      slug {
        current
      }
    }
    ... on Privacy {
      slug {
        current
      }
    }
    ... on Terms {
      slug {
        current
      }
    }
    ... on Homepage {
      slug {
        current
      }
    }
    ... on About {
      slug {
        current
      }
    }
    ... on HowItWorks {
      slug {
        current
      }
    }
  }
  label
  path
}
    `;
export const GlobalDocument = gql`
    query Global {
  header: Header(id: "singleton-header") {
    _id
    _type
    navigation {
      ... on NavigationItem {
        ...NavFragment
      }
    }
  }
  footer: Footer(id: "singleton-footer") {
    _id
    _type
    navigation {
      ... on NavigationItem {
        ...NavFragment
      }
    }
  }
  companyInfo: CompanyInfo(id: "singleton-companyInfo") {
    _id
    _type
    ... on CompanyInfo {
      email
      phone
      legalDisclaimerRaw
    }
  }
  siteSettings: SiteSettings(id: "singleton-siteSettings") {
    _id
    _type
    ... on SiteSettings {
      settings
    }
  }
}
    ${NavFragmentFragmentDoc}`;

/**
 * __useGlobalQuery__
 *
 * To run a query within a React component, call `useGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalQuery(baseOptions?: Apollo.QueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
      }
export function useGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
        }
export type GlobalQueryHookResult = ReturnType<typeof useGlobalQuery>;
export type GlobalLazyQueryHookResult = ReturnType<typeof useGlobalLazyQuery>;
export type GlobalQueryResult = Apollo.QueryResult<GlobalQuery, GlobalQueryVariables>;
export const HomepageDocument = gql`
    query Homepage {
  homepage: Homepage(id: "singleton-homepage") {
    hero {
      ... on Hero {
        image {
          ... on Image {
            _key
            asset {
              ... on SanityImageAsset {
                _id
                _key
                url
              }
            }
          }
        }
        heading
        snippet
        ctaObject {
          ... on CtaObject {
            text
            link
          }
        }
      }
    }
    howItWorksSection {
      ... on HowItWorksSection {
        heading
        snippet
        howItWorksRepeater {
          ... on HowItWorksItem {
            image {
              ... on Image {
                _key
                asset {
                  ... on SanityImageAsset {
                    _id
                    _key
                    url
                  }
                }
              }
            }
            heading
            snippet
          }
        }
        ctaObject {
          ... on CtaObject {
            text
            link
          }
        }
      }
    }
    caseStudies {
      ... on CaseStudies {
        heading
        snippet
        caseStudiesRepeater {
          ... on CaseStudy {
            caseStudy
          }
        }
      }
    }
    getStarted {
      heading
      snippet
      ctaObject {
        ... on CtaObject {
          text
          link
        }
      }
    }
  }
}
    `;

/**
 * __useHomepageQuery__
 *
 * To run a query within a React component, call `useHomepageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepageQuery(baseOptions?: Apollo.QueryHookOptions<HomepageQuery, HomepageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageQuery, HomepageQueryVariables>(HomepageDocument, options);
      }
export function useHomepageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageQuery, HomepageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageQuery, HomepageQueryVariables>(HomepageDocument, options);
        }
export type HomepageQueryHookResult = ReturnType<typeof useHomepageQuery>;
export type HomepageLazyQueryHookResult = ReturnType<typeof useHomepageLazyQuery>;
export type HomepageQueryResult = Apollo.QueryResult<HomepageQuery, HomepageQueryVariables>;